import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getLabBySlug } from "../services/labService";

/**
 * Hook to fetch a single lab by slug
 */
export const useLabDetails = () => {
    const { labSlug } = useParams();
    const [lab, setLab] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchLab = async () => {
            try {
                if (labSlug) {
                    const data = await getLabBySlug(labSlug);
                    setLab(data);
                    setError(null); // clear previous errors if any
                }
            } catch (err) {
                if (err.response?.status === 404) {
                    // Treat as "not found" case
                    setLab(null);
                } else {
                    setError("Something went wrong. Please try again.");
                }
            } finally {
                setLoading(false);
            }
        };
        fetchLab();
    }, [labSlug]);

    return { lab, loading, error };
};